import React from 'react';
import { mpanAlertMessageInvalidLength, mpanAlertMessageNumber } from '../../config/AppConfigurator';
import { SelectedAddress } from '../SelectedAddress/SelectedAddress';
import { AlertMessage } from '../../components/AlertMessage/AlertMessage';
import PropTypes from 'prop-types';

/* IMPORTING LOCAL STYLES FOR POSTCODE */ 
import '../../assets/components/MeterPointAdministrationNumber.scss';

export const MeterPointAdministrationNumber = ({ 
    regexMPANCore, 
    regexMPANFull, 
    queryBtnSpinner, 
    mpan='', 
    queryDetails,
    getMPAN, 
    getMeterDataEnquiryDetails,
    address 
}) => {
    return (
        <>
            <div className="mb-3">
                <label htmlFor="InputMPAN" className="form-label">Search by MPAN</label>
                <input type="text" className="form-control postcode-input"  id="InputMPAN" aria-describedby="MPANHelp" onChange={event => getMPAN(event)}/>
            </div>
            { mpan.length > 0 && !(mpan.match(regexMPANCore) || mpan.match(regexMPANFull)) &&
              <div className="postcode-input">
                <AlertMessage {...mpanAlertMessageInvalidLength} />
              </div>
            }
            { queryDetails && queryDetails[0] && queryDetails[0].elecdetails && queryDetails[0].elecdetails.length === 0 &&
                <div className="postcode-input">
                    <AlertMessage {...mpanAlertMessageNumber} />
                </div>
            }
            <button disabled={!(mpan.match(regexMPANCore) || mpan.match(regexMPANFull))} className="btn btn-danger btn-md meter-point-administration-number-submit-button" onClick={()=>getMeterDataEnquiryDetails()}>
                { queryBtnSpinner ? 
                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    : 
                    'Enquire'
                }
            </button>
            <div className="meter-data-enquiry-panel-component-divider"></div>
              { address && address.length > 0 &&
                <SelectedAddress selectedAddress={ address }  /> 
              }
        </>
    );
};

MeterPointAdministrationNumber.propTypes = {
    /* 
      regax MPAN core for component
    */ 
      regexMPANCore: PropTypes.string.isRequired,
    /* 
      regax MPAN full for component
    */ 
      regexMPANFull: PropTypes.string.isRequired,
    /* 
      address spinner for query button
    */ 
      queryBtnSpinner: PropTypes.bool.isRequired,
    /* 
      mpan for the component
    */ 
      mpan: PropTypes.string.isRequired,
  }
  
  MeterPointAdministrationNumber.defaultProps = {
    /*
        default value if regex MPAN core is not given
    */
      regexMPANCore: '',
    /*
        default value if regex MPAN full list is not given
    */
      regexMPANFull: '',
    /*
        default value if address button spinner is not given
    */
      queryBtnSpinner: false,
    /*
        default value if mpan is not given
    */
      mpan: '',
}